// extracted by mini-css-extract-plugin
export default {"container":"message-chip_container__5F6eP"};